<template>
	<span>
		<div v-if="this.catalogo" @click="click">
			<img :src="catalogo.img_url" class="img-logo" height="60" />
		</div>
		<div v-else>
			<img src="@/assets/logo_seculos.png" class="img-logo" height="52" />
		</div>
	</span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({ catalogo: 'catalogo' }),
	},
	methods: {
		click() {
			this.$router.push(`/${this.catalogo.identificadorCatalogo}${this.retornarQueryVendedor()}`)
		},
	},
}
</script>
<style>
.img-logo {
	vertical-align: middle;
}
</style>